import React from "react";
import ReactDOM from "react-dom/client";
import './index.css';
import App from './App';

window.ReactCalculators = {
  init: (id, props) => {
    const root = ReactDOM.createRoot(document.getElementById(id));
    root.render(<App {...props} />);
  }
};


//const props = { type: "sip" };
//const props = { type: "swp" };
//const props = { type: "inflation" };
//const props = { type: "cagr" };
//const props = { type: "reverse_cagr" };
//const props = { type: "xirr" };

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <App {...props} />
//   </React.StrictMode>
// );
